/**
 * iconMap — FE-side resolver from SDK `iconKey` intent strings to emoji glyphs.
 *
 * No framework imports — emoji are plain strings; zero dependency on Lucide.
 * If TCS swaps icon libraries in a v1.x design refresh, the SDK's `iconKey`
 * intent strings retain their semantic meaning; only this file changes (and
 * the iconBg render in DomainPickerBlock if asset chrome shifts).
 *
 * v1 vocabulary (locked per TDD §3.3):
 *   - 'users-round' → 🏕️  (Enrollment)
 *   - 'hard-hat'    → 👥  (Staff)
 *   - 'home'        → 🛏️  (Bunks)
 *   - 'banknote'    → 💰  (Financial)
 *
 * Fallback (unrecognised iconKey or undefined): '📊'.
 */

const FALLBACK_ICON = '📊'

export const ICON_MAP: Record<string, string> = {
  'users-round': '🏕️',
  'hard-hat': '👥',
  home: '🛏️',
  banknote: '💰',
}

export function resolveIcon(iconKey?: string): string {
  if (!iconKey) return FALLBACK_ICON
  return ICON_MAP[iconKey] ?? FALLBACK_ICON
}
